import { CardTheme } from '@coast/schemas';
import { createContext } from 'react';

export const CardThemeContext = createContext<CardTheme | undefined>(undefined);
